<template>
    <div class="relative z-[99999]" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm transition-opacity"></div>
        <div class="fixed inset-0 z-30 overflow-y-auto">
            <div class="flex min-h-full items-end px-4 pb-16 text-center max-w-lg mx-auto">
                <div class="border-2 border-jackpot-bg flex-1 relative transform overflow-hidden rounded-lg text-left drop-shadow-xl transition-all">
                    <div class="bg-white dark:bg-global-bg p-4">
                        <div class="text-center">
                            <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-gray-50">Watch Race?</h3>
                            <p>Race will start soon...</p>
                        </div>
                    </div>
                    <div class="bg-gray-50 dark:bg-global-bg px-4 py-3 flex flex-col">
                        <button
                            @click.prevent="submit"
                            type="button"
                            class="modal-action-button"
                        >Yes</button>
                        <button
                            @click.prevent="close"
                            type="button"
                            class="modal-cancel-button"
                        >No</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'StartGameModal',
    methods: {
        submit() {
            this.emitter.emit('select-game', null)
        },
        close() {
            this.emitter.emit('close-modal', 'start_game_modal')
        }
    }
}
</script>
